import { ConsultarDatosGeneracionActaAyudaHumanitaria } from '../../../Auth/ConsultasApi';
import ConstruirPdfAyudaHumanitariaFirma from './ConstruirPdfAyudaHumanitariaFirma';
import apiService from '../../../Auth/apiService';

export async function generarPdfAyuda(
    idatencion,
    usrRolid,
    IdCabezaFamilia,
    usrId,
    idProcesoFirma,
    token,
    observacion = 'Acta de entrega firmada digitalmente'
) {
    const ObservacionActa = `Acta firma digital - ${observacion}`;
    const obj = { idatencion: idatencion, usrRolid: usrRolid, usrId: usrId };
    let idPersona = null;
    let datosActa = null;
    let firmaPersona = null;
    let firmaUsuario = null;
    let cedulaLadoA = null;
    let cedulaLadoB = null;
    let constanciaUno = null;
    let constanciaDos = null;
    try {
        const response = await ConsultarDatosGeneracionActaAyudaHumanitaria({ obj, token });
        const result = await response.data;
        datosActa = result;
        idPersona = result.datosacta[0]?.idpersona || null;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
    if (!idPersona) {
        return null;
    }
    firmaUsuario = await consultarFirmaUsuario(usrId, token);
    firmaPersona = await ConsultarFirmaPersona(idProcesoFirma, token);
    cedulaLadoA = await consultarCedulaLadoA(idProcesoFirma , token);
    cedulaLadoB = await consultarCedulaLadoB(idProcesoFirma, token);
    constanciaUno = await consultarConstanciaUno(idProcesoFirma, token);
    constanciaDos = await consultarConstanciaDos(idProcesoFirma, token);
    const url = await generarActa(
        firmaPersona,
        firmaUsuario,
        cedulaLadoA,
        cedulaLadoB,
        constanciaUno,
        constanciaDos,
        usrId,
        datosActa
    );
    const responseGuardar = await guardarActa(ObservacionActa, url, IdCabezaFamilia, idPersona, idatencion, usrId, token);
    if (responseGuardar === 'Archivo subido correctamente') {
        return url;
    }
    console.error('Error al guardar el acta:', responseGuardar);
    return null;
}

async function consultarFirmaUsuario(id, token){
    const url = '/archivo/consultarfirmausuario';
    const obj = { usrId: id };
    try {
        const response = await apiService.getFile(url, obj, token);
        // Recibes un Blob (image/png)
        const blob = response.data;
        if (blob?.type?.startsWith('image/')) {
             return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = () => {
                    reject(new Error('Failed to read the image blob as Data URL'));
                };
                reader.readAsDataURL(blob);
            });
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error fetching firma usuario:', error);
        return null;
    }
}

async function ConsultarFirmaPersona(idProcesoFirma, token) {
    const url = '/archivo/consultarfileaheactadigital';
    const obj = { procesofirmasid: idProcesoFirma, tipoImagen: 'Firma' };
    try {
        const response = await apiService.getFile(url, obj, token);
        const blob = response.data;
        if (blob?.type?.startsWith('image/')) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = () => {
                    reject(new Error('Failed to read the image blob as Data URL'));
                };
                reader.readAsDataURL(blob);
            });
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error fetching firma persona:', error);
        return null;
    }
}

async function consultarCedulaLadoA(idProcesoFirma, token) {
    const url = '/archivo/consultarfileaheactadigital';
    const obj = { procesofirmasid: idProcesoFirma, tipoImagen: 'cedulaA' };
    try {
        const response = await apiService.getFile(url, obj, token);
        // Recibes un Blob (image/png)
        const blob = response.data;
        if (blob?.type?.startsWith('image/')) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = () => {
                    reject(new Error('Failed to read the image blob as Data URL'));
                };
                reader.readAsDataURL(blob);
            });
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error fetching cedula lado A:', error);
        return null;
    }
}

async function consultarCedulaLadoB(idProcesoFirma, token) {
    const url = '/archivo/consultarfileaheactadigital';
    const obj = { procesofirmasid: idProcesoFirma, tipoImagen: 'cedulaB' };
    try {
        const response = await apiService.getFile(url, obj, token);
        // Recibes un Blob (image/png)
        const blob = response.data;
        if (blob?.type?.startsWith('image/')) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = () => {
                    reject(new Error('Failed to read the image blob as Data URL'));
                };
                reader.readAsDataURL(blob);
            });
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error fetching cedula lado B:', error);
        return null;
    }
}

async function consultarConstanciaUno(idProcesoFirma, token) {
    const url = '/archivo/consultarfileaheactadigital';
    const obj = { procesofirmasid: idProcesoFirma, tipoImagen: 'constanciaUno' };
    try {
        const response = await apiService.getFile(url, obj, token);
        // Recibes un Blob (image/png)
        const blob = response.data;
        if (blob?.type?.startsWith('image/')) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = () => {
                    reject(new Error('Failed to read the image blob as Data URL'));
                };
                reader.readAsDataURL(blob);
            });
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error fetching constancia uno:', error);
        return null;
    }
}

async function consultarConstanciaDos(idProcesoFirma, token) {
    const url = '/archivo/consultarfileaheactadigital';
    const obj = { procesofirmasid: idProcesoFirma, tipoImagen: 'constanciaDos' };
    try {
        const response = await apiService.getFile(url, obj, token);
        // Recibes un Blob (image/png)
        const blob = response.data;
        if (blob?.type?.startsWith('image/')) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = () => {
                    reject(new Error('Failed to read the image blob as Data URL'));
                };
                reader.readAsDataURL(blob);
            });
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error fetching constancia dos:', error);
        return null;
    }
}

async function toJpeg(image) {
    return new Promise((resolve) => {
        if (!image) return resolve(null);
        const img = new window.Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL('image/jpeg', 0.92));
        };
        img.src = image;
    });
}

async function generarActa(
    firmaPersona,
    firmaUsuario,
    imageCedulaLadoA,
    imageCedulaLadoB,
    imageEvidenciaEntrega,
    imageEvidenciaEntregaComprobante,
    user,
    datosActa
) {
    const jpegCedulaLadoA = await toJpeg(imageCedulaLadoA);
    const jpegCedulaLadoB = await toJpeg(imageCedulaLadoB);
    const jpegEvidenciaEntrega = await toJpeg(imageEvidenciaEntrega);
    const jpegEvidenciaEntregaComprobante = await toJpeg(imageEvidenciaEntregaComprobante);

    const images = {
        sigCanvas: firmaPersona,
        sigCanvasEntrega: firmaUsuario,
        imageCedulaLadoA: jpegCedulaLadoA,
        imageCedulaLadoB: jpegCedulaLadoB,
        imageEvidenciaEntrega: jpegEvidenciaEntrega,
        imageEvidenciaEntregaComprobante: jpegEvidenciaEntregaComprobante
    };
    const userNombre = datosActa.usrNombre || user;
    const url = await ConstruirPdfAyudaHumanitariaFirma(
        datosActa.datosacta,
        datosActa.encabezado,
        datosActa.formularioactaentrega,
        images, 
        userNombre,
        datosActa.usrIdPersona,
        datosActa.datosMinuta);
    
    return url; 
}

async function guardarActa(observacion, pdfFile, idCabezaFamilia, idPersona, idAtencion, user, token) {
    if (!pdfFile) return;
    const url = '/archivo/upfileactadigital';
    
    const responseFetch = await fetch(pdfFile);
    const blob = await responseFetch.blob();
    // 1. Read file as base64
    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => resolve(reader.result.split(',')[1]); // Only base64 part
        reader.onerror = error => reject(error);
    });

    const base64String = await toBase64(pdfFile);

    // 2. Prepare payload (example for JSON)
    const payload = {
        fileName: pdfFile.name,
        fileType: pdfFile.type,
        contentBase64: base64String,
        observacion: observacion,
        IdCabezaFamilia: idCabezaFamilia,
        perIdPersona: idPersona,
        usrId: user,
        carArchivocentral: false,
        carArchivoubicado: "Archivo digital",
        idAtencion: idAtencion
    };

    // 3. Send to backend

    try {
        let response = await apiService.post(url, payload, token);
        if(response.status === 200){
            return 'Archivo subido correctamente';
        }
    } catch (error) {
        if (error.status === 413) {
            return 'El archivo es demasiado grande para subirlo';
        } else if(error.status === 422){
            return 'Error subiendo archivo: ' + JSON.stringify(error.response.data.errors);
        } else if(error.status === 409){
            return 'Error subiendo archivo: ' + JSON.stringify(error.response.data);
        } else {
            return 'Error subiendo archivo: ' + JSON.stringify(error.response);
        }
    }       
}